<template>
  <div class="common-table">
    <div class="tablebox">

      <div class="lefttable">
        <el-input placeholder="请输入内容" v-model="configleft.name" @change="changePage" clearable></el-input>
        <el-table :data="unitNoExistVOList" height="309px" border v-loading="configleft.loading" @selection-change="handleSelectionChangeleft">
          <el-table-column type="selection" width="40">
          </el-table-column>
          <!-- :width="item.width ? item.width : 125" -->
          <el-table-column show-overflow-tooltip v-for="item in tableLabel" :key="item.prop" :label="item.label">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pager">
          <el-pagination class="pager1" layout="prev, pager, next" :total="configleft.total" :current-page.sync="configleft.page" @current-change="changePage">
          </el-pagination>
        </div>
      </div>
      <div class="bottontable">
        <el-button type="primary" size="mini" @click="saddelection()" :disabled="selectltop">
          选取
        </el-button>
        <el-button type="primary" size="mini" @click="cancel()" :disabled="selectbottom">
          取消
        </el-button>
      </div>

      <div class="lefttable">
        <el-input placeholder="请输入内容" v-model="configright.name" @change="changePage" clearable></el-input>
        <el-table :data="unitExistVOList" height="309px" border v-loading="configright.loading" @selection-change="handleSelectionChangeright">
          <el-table-column type="selection" width="40">
          </el-table-column>
          <el-table-column show-overflow-tooltip v-for="item in tableLabel" :key="item.prop" :label="item.label">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" min-width="180">
            <template slot-scope="scope">
              <el-button size="mini">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="pager">
          <el-pagination class="pager1" layout="prev, pager, next" :total="configright.total" :current-page.sync="configright.page" @current-change="changePage">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "transfertable",
  props: {
    unitExistVOList: Array,
    unitNoExistVOList: Array,
    tableLabel: Array,
    configleft: Object,
    configright: Object,
  },
  data() {
    return {
      multipleSelectionleft: [],
      multipleSelectionright: [],
      selectltop: true,
      selectbottom: true,
      inputleft: "",
    };
  },
  methods: {
    // 取消
    cancel() {
      let unitIdList = [];
      this.multipleSelectionright.forEach((item) => {
        unitIdList.push(item);
      });
      this.$emit("edit", unitIdList);
    },
    // 选取
    saddelection() {
      let unitIdList = [];
      this.multipleSelectionleft.forEach((item) => {
        unitIdList.push(item);
      });
      this.$emit("selection", unitIdList);
    },
    changePage(page) {
      this.$emit("changePage", page, this.inputleft);
    },
    // 右侧多选
    handleSelectionChangeright(val) {
      this.multipleSelectionright = val;
      if (this.multipleSelectionright.length) {
        this.selectbottom = false;
      } else {
        this.selectbottom = true;
      }
    },
    // 左侧多选
    handleSelectionChangeleft(val) {
      this.multipleSelectionleft = val;
      if (this.multipleSelectionleft.length) {
        this.selectltop = false;
      } else {
        this.selectltop = true;
      }
    },
  },
};
</script>

<style scoped>
.common-table {
  /* height: calc(100% - 62px); */
  background-color: #fff;
  position: relative;
}
.pager {
  height: 62px;
  /* background-color: #000; */
  display: flex;

  align-items: center;
  justify-content: center;
}
.tablebox {
  display: flex;
  justify-content: space-between;
}
.lefttable {
  width: 44%;
}
.bottontable {
  margin-top: 9%;
  text-align: center;
  width: 54px;
}
.bottontable .el-button + .el-button {
  margin-left: 0;
  margin-top: 30px;
}
</style>
